import React from "react";
import { ShieldAlert } from "lucide-react";
import { useLocalization } from "../../../hooks/useLocalization";
import { WORK_AUTH_STATUSES } from "../../../constants/interviewScheduling";

export const WorkAuthorizationStep = ({ form, update }) => {
  const { t } = useLocalization();
  const needsReview = form.work_authorization_status === "OTHER" || form.work_authorization_status === "NOT_SURE";

  return (
    <div data-testid="wizard-step-work-authorization" className="space-y-4">
      <div>
        <label className="text-sm font-medium text-gray-700 mb-1 block">{t("careers.wizard.workAuthLabel")}</label>
        <select
          data-testid="apply-work-authorization-select"
          required
          value={form.work_authorization_status}
          onChange={(e) => update({ work_authorization_status: e.target.value })}
          className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm bg-white"
        >
          <option value="">{t("careers.wizard.selectPlaceholder")}</option>
          {WORK_AUTH_STATUSES.map((opt) => (
            <option key={opt.value} value={opt.value}>{t(opt.labelKey)}</option>
          ))}
        </select>
      </div>

      {form.work_authorization_status === "OTHER" && (
        <div>
          <label className="text-sm font-medium text-gray-700 mb-1 block">{t("careers.wizard.workAuthOtherLabel")}</label>
          <textarea
            data-testid="apply-work-authorization-other-input"
            rows={2}
            value={form.work_authorization_other_detail}
            onChange={(e) => update({ work_authorization_other_detail: e.target.value })}
            className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
          />
        </div>
      )}

      {needsReview && (
        <p data-testid="work-authorization-review-notice" className="flex items-start gap-2 text-xs text-amber-700 bg-amber-50 border border-amber-200 rounded-lg p-3">
          <ShieldAlert size={14} className="shrink-0 mt-0.5" /> {t("careers.wizard.workAuthReviewNotice")}
        </p>
      )}

      <label className="flex items-start gap-2 text-xs text-gray-600 leading-relaxed">
        <input data-testid="apply-work-authorization-checkbox" required type="checkbox" checked={form.work_authorization_ack} onChange={(e) => update({ work_authorization_ack: e.target.checked })} className="mt-0.5 shrink-0" />
        <span>{t("careers.workAuthorizationAck")}</span>
      </label>
    </div>
  );
};
